import React, { useState, useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';

import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import { InputText } from 'primereact/inputtext';
import { ToggleButton } from 'primereact/togglebutton';
import Card from '../../../components/card';
import { displayErrors } from '../../../util/diversos';

import Loading from '../../loading';
import { Input155px } from '../../../styles/inputGroup';
import axiosCoto from '../../../services/axiosCoto';
import IconButton from '../../../components/IconButton';

export default function CadastroPasta() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const idUsuario = useSelector((state) => state.auth.user.id);
  const id = get(useParams(), 'id', 0);

  const [descricao, setDescricao] = useState('');
  const [padrao, setPadrao] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!id) return;

    async function getData() {
      try {
        setIsLoading(true);

        const { data } = await axiosCoto.get(`/pasta/${id}`);

        if (data.idUsuario !== idUsuario) {
          toast.error('Acesso Negado');
          navigate('/consultapasta');
        }

        setDescricao(data.descricao.trim());
        setPadrao(data.padrao);
        setIsLoading(false);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    getData();
  }, [dispatch, id, idUsuario, navigate]);

  async function salvarRegistro() {
    try {
      setIsLoading(true);

      const shippingData = {
        descricao,
        padrao,
        idUsuario,
      };

      if (id > 0) {
        await axiosCoto.put(`/pasta/${id}`, shippingData);
        toast.success('Pasta atualizada com sucesso.');
      } else {
        await axiosCoto.post('/pasta', shippingData);
        toast.success('Pasta cadastrada com sucesso.');
      }

      navigate('/consultapasta');
    } catch (err) {
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }
  }

  const handleCancel = () => {
    navigate('/consultapasta');
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let formErros = false;

    if (descricao.length < 3 || descricao.length > 100) {
      formErros = true;
      toast.error('Descrição deve conter de 3 à 100 caracteres.');
    }

    if (formErros) return;

    salvarRegistro();
  };

  return (
    <>
      <Loading isLoading={isLoading} />
      <Card title="Manutenção de Pastas">
        <div className="row form-elo">
          <div className="col-9">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Descrição *
              </Input155px>
              <InputText
                maxLength={100}
                type="text"
                name="descricao"
                value={descricao}
                onChange={e => setDescricao(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon" title="Essa pasta aparecerá sempre como primeira opção">
                Padrão
              </Input155px>
              <ToggleButton
                onLabel="Sim"
                offLabel="Não"
                onIcon="pi pi-check"
                offIcon="pi pi-times"
                checked={padrao}
                onChange={(e) => setPadrao(e.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ textAlign: 'right' }}>
            <IconButton titulo="Salvar" mensagem="Salvar" btnStyle="success" onClick={handleSubmit} icon="check" />
            <IconButton titulo="Cancelar" mensagem="Cancelar" btnStyle="danger" onClick={handleCancel} icon="times" />
          </div>
        </div>
      </Card>
    </>
  );
}
